import React from 'react';

// Analytics Icon - trend/growth chart
export const AnalyticsIcon: React.FC<{ color?: string }> = ({ color = "#1cb4ba" }) => (
  <svg width="100%" height="100%" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* Trend line */}
    <path d="M3 14.5L8.2 9.3L12.1 13.2L19 6.25" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    {/* Top-right axis hint */}
    <path d="M15.5 6.25H19V9.75" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Product Hub Icon - box/package
export const ProductHubIcon: React.FC<{ color?: string }> = ({ color = "#1cb4ba" }) => (
  <svg width="100%" height="100%" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* Larger box */}
    <rect x="4.5" y="5" width="13" height="9.5" rx="1.4" stroke={color} strokeWidth="1.5"/>
    <path d="M11 5V8.4" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M4.5 8.4H17.5" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    {/* Conveyor belt (thicker + bigger wheels) */}
    <path d="M3.8 15.8H18.2" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <circle cx="7.2" cy="17.1" r="1.1" stroke={color} strokeWidth="1.5"/>
    <circle cx="11" cy="17.1" r="1.1" stroke={color} strokeWidth="1.5"/>
    <circle cx="14.8" cy="17.1" r="1.1" stroke={color} strokeWidth="1.5"/>
  </svg>
);

// Trade Data Icon - database/layers
export const TradeDataIcon: React.FC<{ color?: string }> = ({ color = "#1cb4ba" }) => (
  <svg width="100%" height="100%" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="11" cy="6.5" rx="6.5" ry="2.5" stroke={color} strokeWidth="1.5" />
    <path d="M4.5 6.5V15.5" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M17.5 6.5V15.5" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M4.5 15.5A6.5 2.5 0 0 0 17.5 15.5" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

// Scenario Modeling - three sliders
export const ScenarioModelingIcon: React.FC<{ color?: string }> = ({ color = "#1cb4ba" }) => (
  <svg width="100%" height="100%" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* Top slider */}
    <path d="M4 7H18" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <circle cx="8" cy="7" r="2" stroke={color} strokeWidth="1.5"/>
    {/* Middle slider */}
    <path d="M4 11H18" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <circle cx="14" cy="11" r="2" stroke={color} strokeWidth="1.5"/>
    {/* Bottom slider */}
    <path d="M4 15H18" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <circle cx="6.5" cy="15" r="2" stroke={color} strokeWidth="1.5"/>
  </svg>
);

// Documents Icon - file/document
export const DocumentsIcon: React.FC<{ color?: string }> = ({ color = "#1cb4ba" }) => (
  <svg width="100%" height="100%" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.8333 2.75H5.5C4.95 2.75 4.58333 3.11667 4.58333 3.66667V18.3333C4.58333 18.8833 4.95 19.25 5.5 19.25H16.5C17.05 19.25 17.4167 18.8833 17.4167 18.3333V7.33333L12.8333 2.75Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12.8333 2.75V7.33333H17.4167" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M14.6667 11.9167H7.33333" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M14.6667 15.5833H7.33333" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Post Import Adjustment Icon - list with checkmarks
export const PostImportIcon: React.FC<{ color?: string }> = ({ color = "#1cb4ba" }) => (
  <svg width="100%" height="100%" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.25 11L10.0833 12.8333L15.5833 7.33333" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M11 19.25C15.5563 19.25 19.25 15.5563 19.25 11C19.25 6.44365 15.5563 2.75 11 2.75C6.44365 2.75 2.75 6.44365 2.75 11C2.75 15.5563 6.44365 19.25 11 19.25Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Partners Icon - building
export const PartnersIcon: React.FC<{ color?: string }> = ({ color = "#1cb4ba" }) => (
  <svg width="100%" height="100%" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.66667 19.25H18.3333" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M4.58333 19.25V5.5C4.58333 4.39543 5.47876 3.5 6.58333 3.5H11C12.1046 3.5 13 4.39543 13 5.5V19.25" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M13 11H15.4167C16.5212 11 17.4167 11.8954 17.4167 13V19.25" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M7.33333 7.33333H9.16667" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8.25 14.6667H9.16667" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M7.33333 11H9.16667" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Clients Icon - users/people
export const ClientsIcon: React.FC<{ color?: string }> = ({ color = "#1cb4ba" }) => (
  <svg width="100%" height="100%" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.5833 19.25V17.4167C15.5833 16.4442 15.1971 15.5116 14.5095 14.8239C13.8218 14.1362 12.8892 13.75 11.9167 13.75H5.5C4.52754 13.75 3.59492 14.1362 2.90728 14.8239C2.21964 15.5116 1.83333 16.4442 1.83333 17.4167V19.25" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8.70833 10.0833C10.7334 10.0833 12.375 8.44173 12.375 6.41667C12.375 4.3916 10.7334 2.75 8.70833 2.75C6.68327 2.75 5.04167 4.3916 5.04167 6.41667C5.04167 8.44173 6.68327 10.0833 8.70833 10.0833Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M20.1667 19.25V17.4167C20.1662 16.6281 19.9083 15.8623 19.4334 15.2383C18.9585 14.6143 18.2933 14.1682 17.5417 13.9725" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M14.2083 2.8725C14.9618 3.06707 15.6289 3.51325 16.1054 4.13791C16.5819 4.76257 16.8406 5.52959 16.8406 6.31958C16.8406 7.10958 16.5819 7.8766 16.1054 8.50126C15.6289 9.12592 14.9618 9.5721 14.2083 9.76667" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Settings Icon - gear/cog
export const SettingsIcon: React.FC<{ color?: string }> = ({ color = "#1cb4ba" }) => (
  <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.25 1.5l.917 2.059a8.25 8.25 0 013.874 0L16.958 1.5 18.5 3.042l-1.059 2.417a8.25 8.25 0 012.745 2.745L22.603 7.5 24 9l-2.059.917a8.25 8.25 0 010 3.874L24 14.708 22.5 16.25l-2.417-1.059a8.25 8.25 0 01-2.745 2.745L17.5 20.603 16 22l-.917-2.059a8.25 8.25 0 01-3.874 0L10.292 22 8.75 20.458l1.059-2.417a8.25 8.25 0 01-2.745-2.745L4.397 16.25 2.854 14.708l2.059-.917a8.25 8.25 0 010-3.874L2.854 9 4.397 7.5l2.417 1.059a8.25 8.25 0 012.745-2.745L8.75 3.042 10.292 1.5l.958 2.059z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="12" cy="12" r="3.25" stroke={color} strokeWidth="1.5"/>
  </svg>
);

// Help Center Icon - question mark
export const HelpCenterIcon: React.FC<{ color?: string }> = ({ color = "#1cb4ba" }) => (
  <svg width="100%" height="100%" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3.083" y="3.083" width="15.834" height="15.834" rx="3.5" stroke={color} strokeWidth="1.5" />
    <path d="M8.35 9.35C8.51 8.86 8.835 8.44 9.27 8.15C9.706 7.86 10.223 7.72 10.74 7.755C11.257 7.79 11.748 8.0 12.122 8.35C12.495 8.7 12.727 9.164 12.78 9.665C12.78 11.5 10.8 12.35 10.8 12.35" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M11 15.25H11.01" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Logout Icon - logout arrow
export const LogoutIcon: React.FC<{ color?: string }> = ({ color = "#1cb4ba" }) => (
  <svg width="100%" height="100%" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.6667 15.5833L19.25 11L14.6667 6.41667" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M19.25 11H8.25" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8.25 19.25H4.58333C4.03804 19.25 3.51516 19.0337 3.13134 18.6499C2.74752 18.2661 2.53125 17.7432 2.53125 17.1979V4.80208C2.53125 4.25679 2.74752 3.73392 3.13134 3.3501C3.51516 2.96628 4.03804 2.75 4.58333 2.75H8.25" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// TD Intelligence Icon - user inside rounded square
export const IntelligenceIcon: React.FC<{ color?: string }> = ({ color = "#1cb4ba" }) => (
  <svg width="100%" height="100%" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3.083" y="3.083" width="15.834" height="15.834" rx="3.5" stroke={color} strokeWidth="1.5" />
    <path d="M15.125 16.5V15.7083C15.125 14.955 14.826 14.2325 14.2932 13.6997C13.7604 13.1669 13.0379 12.868 12.2846 12.868H9.71538C8.96212 12.868 8.2396 13.1669 7.7068 13.6997C7.174 14.2325 6.875 14.955 6.875 15.7083V16.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M11 11.4583C12.38 11.4583 13.5 10.3383 13.5 8.95833C13.5 7.57833 12.38 6.45833 11 6.45833C9.62 6.45833 8.5 7.57833 8.5 8.95833C8.5 10.3383 9.62 11.4583 11 11.4583Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

